import { ExternalLink, Loader2, Lock, RefreshCw } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import type { Copy } from '@/frontend/pages/Dashboard/Workflows/types'

export default function PageActions({ refreshing, refresh, url, copy }: { refreshing: boolean; refresh: () => void; url: string | null; copy: Copy }) {
  return <div className="flex shrink-0 flex-wrap items-center gap-2">
    <Badge variant="secondary" className="text-[11px] text-muted-foreground"><Lock aria-hidden />{copy.admin_only}</Badge>
    <Button variant="ghost" size="icon-sm" onClick={refresh} disabled={refreshing} aria-label={copy.refresh} title={copy.refresh}>
      {refreshing ? <Loader2 className="size-4 animate-spin" aria-hidden /> : <RefreshCw className="size-4" aria-hidden />}
    </Button>
    {url && <Button asChild variant="outline" className="h-9 px-3 text-[13px] shadow-none"><a href={url} target="_blank" rel="noopener noreferrer">{copy.temporal.view_execution}<ExternalLink className="size-3.5" aria-hidden /></a></Button>}
  </div>
}
